package com.milta.core.localization.translations.es

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Equipo",
    statusActive = "Activa",
    errorGeneric = "Se produjo un error. Por favor, inténtalo de nuevo.",
    monthNames = listOf("enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"),
    enterpriseSectionLabel = "Conductores del equipo",
    enterpriseEmptyHint = "Todavía no hay conductores en tu equipo.",
    noEnterpriseFound = "Ninguna empresa vinculada a tu cuenta.",
    columnHeaderDriver = "Conductor",
    columnHeaderStatus = "Estado",
    columnHeaderActions = "Acciones",
    addDriverSectionTitle = "Añadir un conductor",
    addDriverCodePlaceholder = "Código Milta — ej. MTA-28371",
    addDriverButton = "Añadir este conductor",
    addDriverErrorInvalidCode = "Introduce un código válido.",
    addDriverErrorNotFound = "Código inválido o ya utilizado.",
    addDriverErrorAlreadyMember = "Este conductor ya forma parte de tu equipo.",
    addDriverErrorLinkedAccountIsEnterprise = "Esta cuenta es una empresa y no se puede añadir como conductor.",
    addDriverErrorLimitReached = "Límite alcanzado: una empresa no puede tener más de 10 miembros, tú incluido. Elimina un conductor para añadir otro.",
    addDriverErrorEnterpriseSubscriptionInactive = "Tu suscripción de Empresa ha caducado: renuévala para añadir un conductor.",
    driverDetailTitle = "Datos del conductor",
    driverDetailPhoneLabel = "Teléfono",
    removeDriverButton = "Quitar",
    removeDriverDialogTitle = "¿Quitar a este conductor?",
    removeDriverDialogMessagePrefix = "Estás a punto de quitar a",
    removeDriverDialogMessageSuffix = "de tu equipo. Su cuenta Milta seguirá activa.",
    removeDriverErrorNotFound = "Conductor no encontrado.",
    removeDriverErrorOnActiveDelivery = "Este conductor está actualmente realizando una entrega y no se puede quitar.",
    removeDriverErrorLastOwner = "Eres el único gestor de esta empresa. Añade otra cuenta de Empresa antes de eliminarte del equipo.",
)
